export const define = {
  free: "Free",
  nonprofit: "Non-Profit",
  professional: "Professional",
  team: "Team",
  teamplus: "Team Plus",
  enterprise: "Enterprise",
};

export default define;
